import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Newsletter} from './model';

export interface NewsletterState extends EntityState<Newsletter> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Newsletter' })
export class Store extends EntityStore<NewsletterState> {

  constructor() {
    super();
  }

}
